import { CartProvider, ShopifyProvider, useShopifyCookies } from '@shopify/hydrogen-react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import IframeBridge from './IframeBridge';
import UrlContextSync from './UrlContextSync';
import NotFound from './NotFound';
import { NotificationMessages } from '../../common/notificationMessages';
import FlashMessages from '../../components/ui/FlashMessages';
import ElevarInitialization from '../../utils/elevarInitialization';
import { useGoogleAnalytics } from '../../utils/ga';
import ScrollToTop from '../../utils/scrollToTop';
import { CART_QUERY_FRAGMENT } from '../../utils/storefront/cart/queries';
import CartPage from '../cart/CartPage';
import CollectionPage from '../collections/CollectionPage';
import DemoParent from '../demo/DemoParent';
import ProductPage from '../products/ProductPage';

const App = () => {
  useShopifyCookies({ hasUserConsent: true });
  useGoogleAnalytics();

  return (
    <ShopifyProvider
      storeDomain={process.env.REACT_APP_SHOPIFY_STORE_DOMAIN ?? ''}
      storefrontToken={process.env.REACT_APP_SHOPIFY_STORE_API_PUBLIC_TOKEN ?? ''}
      storefrontApiVersion={process.env.REACT_APP_SHOPIFY_STORE_API_VERSION ?? ''}
      countryIsoCode="US"
      languageIsoCode="EN"
    >
      <CartProvider
        cartFragment={CART_QUERY_FRAGMENT}
        onLineAddComplete={() => FlashMessages.success(NotificationMessages.PRODUCT_ADDED)}
        onLineRemoveComplete={() => FlashMessages.success(NotificationMessages.PRODUCT_REMOVED)}
        onLineUpdateComplete={() => FlashMessages.success(NotificationMessages.CART_UPDATED)}
      >
        <BrowserRouter
          future={{
            v7_relativeSplatPath: true,
            v7_startTransition: true,
          }}
        >
          <UrlContextSync />
          <IframeBridge />
          {process.env.NODE_ENV !== 'development' && <ElevarInitialization />}
          <ScrollToTop />
          <Routes>
            <Route path="/collection/:collection" element={<CollectionPage />} />
            <Route path="/product/:product" element={<ProductPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/demo/:orgId" element={<DemoParent />} />
            <Route path="/*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </ShopifyProvider>
  );
};

export default App;
